import React from 'react';

const FEATURES = [
  { icon: '💰', title: 'Guaranteed Best Price',  desc: "We scan hundreds of fares so you don't have to. Find it cheaper elsewhere? We'll match it.", gradient: 'from-emerald-500 to-teal-600',   bg: 'bg-emerald-50' },
  { icon: '⚡', title: 'Instant Confirmation',   desc: 'Book in under 3 minutes and receive your e-ticket instantly in your inbox.',              gradient: 'from-amber-500 to-orange-600', bg: 'bg-amber-50'   },
  { icon: '🔒', title: 'Bank-Grade Security',    desc: 'Your personal and payment data is protected with 256-bit SSL encryption.',                gradient: 'from-blue-500 to-indigo-600',  bg: 'bg-blue-50'    },
  { icon: '🔄', title: 'Flexible Changes',       desc: 'Plans change. Modify or cancel your booking from your account anytime.',                  gradient: 'from-violet-500 to-purple-600', bg: 'bg-violet-50' },
  { icon: '📱', title: '24/7 Human Support',     desc: 'Real people available around the clock via chat, phone or email — no bots.',              gradient: 'from-pink-500 to-rose-600',    bg: 'bg-pink-50'    },
  { icon: '🏆', title: 'All Major Airlines',     desc: 'Delta, American, United, Southwest, JetBlue and more — all in one search.',               gradient: 'from-orange-500 to-red-600',   bg: 'bg-orange-50'  },
];

export default function FeaturesSection() {
  return (
    <section className="bg-gray-50 py-16 sm:py-24 px-4">
      <div className="max-w-6xl mx-auto">

        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block bg-violet-100 text-violet-600 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-3 sm:mb-4">
            Why 1ClickBooking
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900">
            Everything You Need to Fly Smarter
          </h2>
          <p className="text-gray-400 mt-3 text-base sm:text-lg max-w-xl mx-auto">
            The simplest, most transparent way to find and book flights.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {FEATURES.map(f => (
            <div
              key={f.title}
              className="bg-white rounded-2xl p-5 sm:p-7 border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className={`inline-flex w-12 h-12 sm:w-14 sm:h-14 rounded-2xl ${f.bg} items-center justify-center text-2xl sm:text-3xl mb-4 sm:mb-5`}>
                {f.icon}
              </div>
              <div className={`h-1 w-8 rounded-full bg-gradient-to-r ${f.gradient} mb-3 sm:mb-4 group-hover:w-14 transition-all duration-300`} />
              <h3 className="font-bold text-gray-900 text-sm sm:text-base mb-2">{f.title}</h3>
              <p className="text-gray-500 text-xs sm:text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
